// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202608312104/js/" + chunkId + "." + {"44":"8724f6d1","225":"e4f10cb6","481":"71e02113","486":"0991772f","770":"c496aaf7"}[chunkId] + ".0.3128557210937305.chunk.js";
};